"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostMessageAdapter = void 0;
const ClientAdapter_1 = require("./ClientAdapter");
const Types_1 = require("./Types");
class PostMessageAdapter extends ClientAdapter_1.ClientAdapter {
    constructor(options) {
        super(options);
        this.setName();
        this.setMessageProtocol();
    }
    setHandler() {
        this.handler = window;
    }
    setName() {
        this.name = Types_1.ClientAdapters.PostMessageAdapter;
    }
    setMessageProtocol() {
        this.messageProtocol = 'postMessage';
    }
    sendMessage(message, targetOrigin) {
        this.handler.postMessage(message, targetOrigin);
    }
}
exports.PostMessageAdapter = PostMessageAdapter;
//# sourceMappingURL=PostMessageAdapter.js.map